import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '@shared/providers/utils.service';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-recovery-password-form',
  templateUrl: './recovery-password-form.page.html',
  styleUrls: ['./recovery-password-form.page.scss']
})
export class RecoveryPasswordFormPage implements OnInit {
  public recoveryForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private router: Router,
    private loginService: LoginService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.recoveryForm = this.initializeForm();
  }

  initializeForm() {
    return this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])]
    });
  }

  get email() {
    return this.recoveryForm.get('email');
  }

  async send(form: FormGroup) {
    if (form.invalid) {
      this.utils.validateAllFields(form);
      this.utils.showToast('', `${this.translate.instant('RECOVERY_PASSWORD.CHECK_THE_FIELDS')}`);
    } else {
      try {
        this.utils.presentLoading(`${this.translate.instant('RECOVERY_PASSWORD.SENDING_REQUEST')}`);
        await this.loginService.requestPasswordChange(this.email.value);
        this.utils.showToast('', `${this.translate.instant('RECOVERY_PASSWORD.YOUR_REQUEST_HAS')}`);
        this.router.navigateByUrl('login');
      } catch (error) {
        console.error(error);
        if (error?.error?.code) {
          this.utils.showToast('', error.error.message);
        } else {
          this.utils.showToast('', `${this.translate.instant('RECOVERY_PASSWORD.ERROR_SENDING_PASSWORD')}`);
        }
      } finally {
        this.utils.dismissLoading();
      }
    }
  }
}
